import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FxForwardAccumulator } from '@/store/forwardAccumulator/state.ts';

export const SavedForwardAccumulatorValidator = arkScope.type({
  'clientId?': 'number',
  properties: {
    'clientsWay?': "'Buy' | 'Sell'",
    'currencyPair?': 'string',
    'cutOffMarketPlace?': 'string',
    'deliveryDate?': 'string | null',
    'expiryDate?': 'string | null',

    'notional?': 'number | null',
    'notionalCurrencyIndex?': 'CurrencyChoice',
    'premiumDate?': 'string | null',
    amountMode: "'Fixing' | 'Total'",
    'leverage?': 'number',
    'leverageAmount?': 'number',

    'strike?': 'number',
    'step?': 'number | null',
    'ekiTrigger?': 'number',
    'akoTrigger?': 'number',

    'firstFixingDate?': 'string',
    'lastFixingDate?': 'string',
    'marginCurrency?': 'string',
    'numberOfFixings?': 'number',
    'numberOfSettlements?': 'number',
    'markupCurrency?': 'string',
    'fixingFrequency?': 'Frequency',
    'settlementFrequency?': 'Frequency',
    'isCrossed?': 'boolean',
    'crossCurrency?': 'string',
    'maxDate?': 'string',
  },
  tileId: 'string',
  type: "'ForwardAccumulator'",
});

export type SavedForwardAccumulator = typeof SavedForwardAccumulatorValidator.infer;

export const SavedForwardAccumulator = {
  fromForwardAccumulator: (forwardAccumulator: FxForwardAccumulator, tileId: string): SavedForwardAccumulator => {
    return {
      clientId: forwardAccumulator.clientId,
      properties: {
        clientsWay: forwardAccumulator.properties.clientsWay,
        currencyPair: forwardAccumulator.properties.currencyPair,
        cutOffMarketPlace: forwardAccumulator.properties.cutOffMarketPlace,
        deliveryDate: forwardAccumulator.properties.deliveryDate,
        expiryDate: forwardAccumulator.properties.expiryDate,
        notional: forwardAccumulator.properties.notional,
        notionalCurrencyIndex: forwardAccumulator.properties.notionalCurrencyIndex,
        premiumDate: forwardAccumulator.properties.premiumDate,
        amountMode: forwardAccumulator.properties.amountMode,
        leverage: forwardAccumulator.properties.leverage,
        leverageAmount: forwardAccumulator.properties.leverageAmount,
        strike: forwardAccumulator.properties.strike,
        ekiTrigger: forwardAccumulator.properties.ekiTrigger,
        firstFixingDate: forwardAccumulator.properties.firstFixingDate,
        lastFixingDate: forwardAccumulator.properties.lastFixingDate,
        marginCurrency: forwardAccumulator.properties.marginCurrency,
        numberOfFixings: forwardAccumulator.properties.numberOfFixings,
        numberOfSettlements: forwardAccumulator.properties.numberOfSettlements,
        markupCurrency: forwardAccumulator.properties.markupCurrency,
        fixingFrequency: forwardAccumulator.properties.fixingFrequency,
        settlementFrequency: forwardAccumulator.properties.settlementFrequency,
        isCrossed: forwardAccumulator.properties.isCrossed,
        crossCurrency: forwardAccumulator.properties.crossCurrency,
        maxDate: forwardAccumulator.properties.maxDate,
        akoTrigger: forwardAccumulator.properties.akoTrigger,
        step: forwardAccumulator.properties.step,
      },
      tileId,
      type: 'ForwardAccumulator',
    };
  },
} as const;
